import isEqual from 'lodash-es/isEqual';
import pick from 'lodash-es/pick';
export const hasChargeLimitValuesChanged = (values, initialValues) => {
    const chargeLimitValues = ['setChargeLimit', 'chargeLimit'];
    return !isEqual(pick(values, chargeLimitValues), pick(initialValues, chargeLimitValues));
};
